// Tour Package Data for Popular Taxi Tour Packages
// Contains destination-specific pricing, vehicle options, and comprehensive visitor guides

export const tourPackageData = {
  'chandigarh-dalhousie': {
    from: 'Chandigarh',
    to: 'Dalhousie',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      alt: 'White Maruti Dzire sedan car for Chandigarh to Dalhousie tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 9900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      alt: 'Toyota Etios sedan for comfortable Chandigarh to Dalhousie travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 10800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc1bb1c7-1768370735522.png",
      alt: 'Maruti Brezza compact SUV for Chandigarh to Dalhousie journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 11700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dalhousie tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 15300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dalhousie travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 18900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dalhousie trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dalhousie'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 27000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 17 seater for large group Dalhousie tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dalhousie travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dalhousie tour'
    }],

    visitorsGuide: {
      title: 'Experience the Scenic Chandigarh to Dalhousie Journey with Advait Tour and Travels',
      intro: 'Introducing Advait Tour and Travels, your reliable travel companion for trips between Chandigarh and Dalhousie. Dalhousie, a charming hill station, is known for its colonial architecture and panoramic views.',
      sections: [
      {
        title: 'Highlight of Advait Tour and Travels Services',
        content: 'We provide a range of options in our Chandigarh to Dalhousie tour packages to accommodate every traveler\'s budget and tastes. Our packages are suitable for both short-term and long-term travel needs. Each of our packages is designed to guarantee you enjoy the time of your life amid the breathtaking Himalayan scenery.'
      },
      {
        title: 'Your comfort, security, and happiness are our top priorities',
        content: 'At Advait Tour and Travels, a pleasant and easy ride is guaranteed by our fleet of well-maintained cars and our experienced and courteous drivers. We are the go-to option for tourists seeking a hassle-free trip because of our flexible schedule, which enables you to travel whenever it suits you.'
      },
      {
        title: 'Highlight of Advait Tour and Travels Services',
        subsections: [
        {
          subtitle: '1. Comfortable Vehicles',
          content: 'We know how important it is to travel comfortably, especially for long trips. Our fleet includes pristine, well-equipped cars to meet your demands. Our vehicles are roomy, spotless, and equipped with modern amenities to guarantee a relaxing journey for you and your fellow passengers. Whether you\'re going alone, with family, or in a group, we have the ideal car to meet your requirements.'
        },
        {
          subtitle: '2. Flexible Scheduling',
          content: 'Understanding that every traveler has unique preferences, we offer various scheduling options. Our staff will work with you to plan a departure time that fits your schedule, whether daytime or nighttime. Additionally, our flexible pick-up and drop-off points enables you to start and end your journey at your preferred locations.'
        },
        {
          subtitle: '3. Tailored Packages',
          content: 'We are committed to providing experiences tailored to your preferences. You can modify our Chandigarh to Dalhousie tour packages to suit your needs and budget by adding or removing services. Whether you want to include sightseeing, adventure activities, or cultural experiences, we can create a customized package for you.'
        },
        {
          subtitle: '4. Transparent Pricing',
          content: 'At Advait Tour and Travels, we believe in honest, upfront pricing with no hidden fees. The rates for our Chandigarh to Dalhousie trip packages are stated clearly, including taxes, tolls, and driver allowances, so you can plan your trip without worries.'
        }]

      },
      {
        title: 'Explore Chandigarh with Our Taxi Tour Package from Dalhousie',
        content: 'You can easily visit the lively city of Chandigarh with our hassle-free taxi package from Dalhousie to Chandigarh, provided by Advait Tour and Travels. Designed for a memorable and enjoyable experience, our Chandigarh taxi tour package from Dalhousie offers flexible options.',
        subsections: [
        {
          subtitle: '1. Flexible Itinerary',
          content: 'Our customizable schedule allows you to explore Chandigarh at your own pace. Whether you wish to visit the famous Rock Garden, take a leisurely walk in the Rose Garden, or marvel at the Capitol Complex, our drivers will accommodate your preferences.'
        },
        {
          subtitle: '2. Convenient transportation',
          content: 'Say goodbye to the hassles of public transit or self-driving. Our knowledgeable drivers transport you in a cozy vehicle, allowing you to relax and enjoy the scenic drive from Dalhousie to Chandigarh.'
        },
        {
          subtitle: '3. Smooth travel experience',
          content: 'Ride in our well-maintained, comfortable cars equipped with modern amenities. Our vehicles provide a stress-free experience, whether traveling solo, with family, or in a group.'
        },
        {
          subtitle: '4. Professional advice',
          content: 'Our drivers can also provide insights about Chandigarh\'s attractions, culture, and tourist spots. Feel free to ask for recommendations or information on the places you visit.'
        }]

      },
      {
        title: 'Why Choose Advait Tour and Travels for Tour Packages',
        subsections: [
        {
          subtitle: '1. Exceptional Customer Satisfaction',
          content: 'Customer satisfaction is our first goal at Advait Tour and Travels. Our dedicated team works tirelessly to ensure every part of your vacation exceeds expectations. From booking to checkout, we provide the best service and support.'
        },
        {
          subtitle: '2. Reasonable Rates with No Hidden Fees',
          content: 'We believe everyone should enjoy travel without financial stress. Our trip packages are affordable and transparent, with no added costs or surprises. You receive excellent value for your money.'
        },
        {
          subtitle: '3. Wide Range of Destinations and Packages',
          content: 'We offer a variety of Chandigarh to Dalhousie packages catering to different interests, including relaxing beaches, thrilling mountain hikes, and vibrant urban experiences. Our flexible options suit every traveler.'
        },
        {
          subtitle: '4. Professional Advice and Support',
          content: 'Our experienced travel advisors are available to assist at every step. We help you select the perfect destination and create an itinerary that matches your preferences and budget.'
        },
        {
          subtitle: '5. Easy Booking Process',
          content: 'Booking with Advait Tour and Travels is simple, fast, and hassle-free. Use our website or call our support team to reserve your spot. We offer flexible payment options and instant confirmation.'
        }]

      },
      {
        title: 'Book Your Chandigarh to Dalhousie Tour Package Today',
        content: 'Ready to explore the scenic beauty of Dalhousie and Chandigarh? Book your Chandigarh to Dalhousie tour package today with Advait Tour and Travels. Contact us now to reserve your vehicle and start your unforgettable journey.'
      }]
    }
  },
  'chandigarh-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '1-day', label: '1 Day' },
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 5500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'White Maruti Dzire sedan car for Chandigarh to Shimla tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 6000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
      alt: 'Toyota Etios sedan for comfortable Chandigarh to Shimla travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 6500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128fe23b0-1768380108426.png",
      alt: 'Maruti Brezza compact SUV for Chandigarh to Shimla journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 7000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Shimla tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Shimla travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 11000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Shimla trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 14500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 12 seater for group travel to Shimla'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 15500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 17 seater for large group Shimla tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 19500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      alt: 'Force Urbania 16 seater luxury van for premium Shimla travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 19500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aa88d0b3-1766989338775.png",
      alt: 'Tempo Traveller 25 seater for extra large group Shimla tour'
    }],

    visitorsGuide: {
      title: 'Chandigarh to Shimla Taxi Tour Packages',
      intro: 'Experience the scenic beauty of Shimla with Sardar Travels. Book your Chandigarh to Shimla tour package with comfortable vehicles and professional drivers.',
      sections: [
      {
        title: 'Chandigarh to Shimla Tour Package',
        content: 'Enjoy a memorable trip to Shimla from Chandigarh with our flexible tour packages. Choose from 1-day to 4-day packages with a wide range of vehicles.'
      }]

    }
  },
  'chandigarh-manali': {
    from: 'Chandigarh',
    to: 'Manali',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '1-day', label: '1 Day' },
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 7500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b725c90-1768360984929.png",
      alt: 'White Maruti Dzire sedan car for Chandigarh to Manali tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 8200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'Toyota Etios sedan for comfortable Chandigarh to Manali travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 8400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef04795b-1768380108447.png",
      alt: 'Maruti Brezza compact SUV for Chandigarh to Manali journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 9100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Manali tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 12300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Manali travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 15100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Manali trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 19900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9851b8f-1768447109831.png",
      alt: 'Tempo Traveller 12 seater for group travel to Manali'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 21300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 17 seater for large group Manali tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 26700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      alt: 'Force Urbania 16 seater luxury van for premium Manali travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 26700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 25 seater for extra large group Manali tour'
    }],

    visitorsGuide: {
      title: 'Chandigarh to Manali Taxi Tour Packages',
      intro: 'Discover the breathtaking beauty of Manali with Sardar Travels. Book your Chandigarh to Manali tour package with a variety of vehicle options.',
      sections: [
      {
        title: 'Chandigarh to Manali Tour Package',
        content: 'Plan your perfect Manali getaway from Chandigarh with our customizable tour packages. Choose from 1-day to 4-day packages.'
      }]

    }
  },
  'chandigarh-amritsar': {
    from: 'Chandigarh',
    to: 'Amritsar',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '1-day', label: '1 Day' },
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 7000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'White Maruti Dzire sedan car for Chandigarh to Amritsar tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 7700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Etios sedan for comfortable Chandigarh to Amritsar travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 8400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc1bb1c7-1768370735522.png",
      alt: 'Maruti Brezza compact SUV for Chandigarh to Amritsar journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 9100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Amritsar tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 11900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Amritsar travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 14700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Amritsar trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 19600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 12 seater for group travel to Amritsar'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 17 seater for large group Amritsar tour'
    },
    {
      type: 'Urbania',
      luggage: 9,
      seats: 12,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      alt: 'Urbania 12 seater luxury van for premium Amritsar travel'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1414fbf22-1768624623341.png",
      alt: 'Force Urbania 16 seater luxury van for premium Amritsar travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1942669-1768440186993.png",
      alt: 'Tempo Traveller 25 seater for extra large group Amritsar tour'
    }],

    visitorsGuide: {
      title: 'Chandigarh to Amritsar Taxi Tour Packages',
      intro: 'Visit the Golden Temple and explore Amritsar with Sardar Travels. Book your Chandigarh to Amritsar tour package with comfortable vehicles.',
      sections: [
      {
        title: 'Chandigarh to Amritsar Tour Package',
        content: 'Experience the spiritual and cultural richness of Amritsar with our tour packages from Chandigarh. Choose from 1-day to 3-day packages.'
      }]

    }
  },
  'amritsar-dharamshala': {
    from: 'Amritsar',
    to: 'Dharamshala',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 11000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png",
      alt: 'White Maruti Dzire sedan car for Amritsar to Dharamshala tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 12100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Etios sedan for comfortable Amritsar to Dharamshala travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 13200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Amritsar to Dharamshala journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 14300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dharamshala tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 18700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dharamshala travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 23100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dharamshala trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11fa0872b-1768440186823.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dharamshala'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      alt: 'Tempo Traveller 17 seater for large group Dharamshala tour'
    },
    {
      type: 'Fortuner',
      luggage: 5,
      seats: 6,
      price: 31500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      alt: 'Toyota Fortuner luxury SUV for premium Dharamshala travel'
    },
    {
      type: 'Urbania',
      luggage: 9,
      seats: 12,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5859f69-1768624625547.png",
      alt: 'Urbania 12 seater luxury van for premium Dharamshala travel'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dharamshala travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11fa0872b-1768440186823.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dharamshala tour'
    }],

    visitorsGuide: {
      title: 'Amritsar to Dharamshala Taxi Tour Packages',
      intro: 'Experience the spiritual beauty of Dharamshala with Sardar Travels. Book your Amritsar to Dharamshala tour package with comfortable vehicles and professional drivers.',
      sections: [
      {
        title: 'Amritsar to Dharamshala Tour Package',
        content: 'Enjoy a memorable trip to Dharamshala from Amritsar with our flexible tour packages. Choose from 2-day to 5-day packages with a wide range of vehicles.'
      }]

    }
  },
  'amritsar-dalhousie': {
    from: 'Amritsar',
    to: 'Dalhousie',
    companyName: 'Sardar Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'White Maruti Dzire sedan car for Amritsar to Dalhousie tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 9900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png",
      alt: 'Toyota Etios sedan for comfortable Amritsar to Dalhousie travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 10800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Amritsar to Dalhousie journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 11700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dalhousie tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 15300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dalhousie travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 18900,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dalhousie trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dalhousie'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 27000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 17 seater for large group Dalhousie tour'
    },
    {
      type: 'Fortuner',
      luggage: 5,
      seats: 6,
      price: 31500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Toyota Fortuner luxury SUV for premium Dalhousie travel'
    },
    {
      type: 'Urbania',
      luggage: 9,
      seats: 12,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Urbania 12 seater luxury van for premium Dalhousie travel'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dalhousie travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dalhousie tour'
    }],

    visitorsGuide: {
      title: 'Amritsar to Dalhousie Taxi Tour Packages',
      intro: 'Discover the scenic beauty of Dalhousie with Sardar Travels. Book your Amritsar to Dalhousie tour package with a variety of vehicle options.',
      sections: [
      {
        title: 'Amritsar to Dalhousie Tour Package',
        content: 'Plan your perfect Dalhousie getaway from Amritsar with our customizable tour packages. Choose from 2-day to 5-day packages.'
      }]

    }
  },
  // Patiala Tour Packages
  'patiala-agra': {
    from: 'Patiala',
    to: 'Agra',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 11000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'White Maruti Dzire sedan car for Patiala to Agra tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 12100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Etios sedan for comfortable Patiala to Agra travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 13200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Patiala to Agra journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 14300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Agra tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 18700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Agra travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 23100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Agra trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 12 seater for group travel to Agra'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 17 seater for large group Agra'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Agra travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 25 seater for extra large group Agra'
    }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-amarnath': {
    from: 'Patiala',
    to: 'Amarnath',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 16000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'White Maruti Dzire sedan car for Patiala to Amarnath tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 17600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png",
      alt: 'Toyota Etios sedan for comfortable Patiala to Amarnath travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 19200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Patiala to Amarnath journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 20800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Amarnath tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 27200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Amarnath travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Amarnath trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 44800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 12 seater for group travel to Amarnath'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 48000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 17 seater for large group Amarnath tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 60800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      alt: 'Force Urbania 16 seater luxury van for premium Amarnath travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 60800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 25 seater for extra large group Amarnath tour'
    }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-amritsar': {
    from: 'Patiala',
    to: 'Amritsar',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 7500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'White Maruti Dzire sedan car for Patiala to Amritsar tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 8250,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'Toyota Etios sedan for comfortable Patiala to Amritsar travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 9000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Patiala to Amritsar journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 9750,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Amritsar tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 12750,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Amritsar travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 15750,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Amritsar trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9851b8f-1768447109831.png",
      alt: 'Tempo Traveller 12 seater for group travel to Amritsar'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 17 seater for large group Amritsar'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Amritsar travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 25 seater for extra large group Amritsar'
    }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-dalhousie': {
    from: 'Patiala',
    to: 'Dalhousie',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 12000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'White Maruti Dzire sedan car for Patiala to Dalhousie tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 13200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'Toyota Etios sedan for comfortable Patiala to Dalhousie travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 14400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Patiala to Dalhousie journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 15600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dalhousie tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 20400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dalhousie travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dalhousie trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dalhousie'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 17 seater for large group Dalhousie tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dalhousie travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dalhousie tour'
    }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-dharamshala': {
    from: 'Patiala',
    to: 'Dharamshala',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 14700,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'White Maruti Dzire sedan car for Patiala to Dharamshala tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 16170,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png",
      alt: 'Toyota Etios sedan for comfortable Patiala to Dharamshala travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 17640,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Patiala to Dharamshala journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 19110,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dharamshala tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 24990,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dharamshala travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 30870,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dharamshala trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 41160,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dharamshala'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 44100,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 17 seater for large group Dharamshala tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 55860,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dharamshala travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 55860,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dharamshala tour'
    }],

    visitorsGuide: {
      title: 'Experience the Spiritual Amritsar to Dharamshala Journey with Advait Tour and Travels',
      intro: 'Discover the spiritual and scenic beauty of Dharamshala with Advait Tour and Travels, your trusted travel partner for journeys from Chandigarh to Dharamshala. Nestled in the Kangra Valley of Himachal Pradesh, Dharamshala is renowned for its Tibetan culture, monasteries, cricket stadium, and breathtaking mountain views. We are dedicated to making your Chandigarh to Dharamshala journey comfortable, safe, and memorable.',
      sections: [
      {
        title: 'Comprehensive Tour Packages',
        content: 'Our Chandigarh to Dharamshala tour packages offer flexible options ranging from 2 to 8 days, catering to different travel preferences and budgets. Whether you\'re planning a quick weekend getaway or an extended spiritual retreat, we have the perfect package for you. Each tour is designed to help you explore the best of Dharamshala and its surrounding attractions.'
      },
      {
        title: 'Comfortable and Safe Travel',
        content: 'Your safety and comfort are paramount to us. Our fleet consists of well-maintained vehicles ranging from sedans to large tempo travellers, all equipped with modern amenities. Our experienced and courteous drivers ensure a smooth journey through the scenic mountain roads, making your trip both safe and enjoyable.'
      },
      {
        title: 'Key Features of Our Services',
        subsections: [
        {
          subtitle: '1. Wide Vehicle Selection',
          content: 'Choose from our diverse fleet including Maruti Dzire, Toyota Etios, Brezza, Maruti Ertiga, Innova Crysta, Innova Hycross, Tempo Travellers (12, 17, and 25 seaters), and Force Urbania. Each vehicle is regularly serviced and cleaned to ensure maximum comfort during your journey.'
        },
        {
          subtitle: '2. Flexible Itineraries',
          content: 'We understand that every traveler has unique preferences. Our tour packages can be customized to include visits to McLeod Ganj, Bhagsu Waterfall, Dalai Lama Temple, Triund Trek, and other popular attractions. Tell us your interests, and we\'ll create the perfect itinerary for you.'
        },
        {
          subtitle: '3. Experienced Drivers',
          content: 'Our drivers are not just skilled at navigating mountain roads; they are also knowledgeable about local attractions, culture, and the best places to visit. They ensure your journey is informative and enjoyable, acting as both driver and guide.'
        },
        {
          subtitle: '4. Transparent Pricing',
          content: 'We believe in honest and upfront pricing. All our rates are clearly mentioned with no hidden charges. The prices include taxes, tolls, and driver allowances, so you know exactly what you\'re paying for. No surprises, just great value for money.'
        }]

      },
      {
        title: 'Popular Attractions in Dharamshala',
        subsections: [
        {
          subtitle: 'McLeod Ganj',
          content: 'The residence of His Holiness the Dalai Lama, McLeod Ganj is the heart of Tibetan culture in India. Visit the Tsuglagkhang Complex, explore Tibetan markets, and enjoy authentic Tibetan cuisine.'
        },
        {
          subtitle: 'Bhagsu Waterfall',
          content: 'A popular trekking destination, Bhagsu Waterfall offers stunning views and a refreshing experience. The trek is moderate and suitable for most fitness levels.'
        },
        {
          subtitle: 'Triund Trek',
          content: 'For adventure enthusiasts, the Triund Trek is a must-do. This moderate trek offers panoramic views of the Dhauladhar range and is perfect for camping under the stars.'
        },
        {
          subtitle: 'Kangra Fort',
          content: 'One of the oldest forts in India, Kangra Fort showcases the rich history and architecture of the region. It\'s a great place for history buffs and photography enthusiasts.'
        },
        {
          subtitle: 'Norbulingka Institute',
          content: 'Dedicated to preserving Tibetan culture and art, the Norbulingka Institute features beautiful gardens, temples, and workshops where you can see traditional crafts being made.'
        }]

      },
      {
        title: 'Why Choose Advait Tour and Travels',
        subsections: [
        {
          subtitle: '1. Customer-Centric Approach',
          content: 'We prioritize your satisfaction above all else. From the moment you book with us until you complete your journey, our team is dedicated to ensuring you have a wonderful experience.'
        },
        {
          subtitle: '2. 24/7 Customer Support',
          content: 'Our customer support team is available round the clock to assist you with bookings, queries, or any issues during your trip. We\'re just a phone call away.'
        },
        {
          subtitle: '3. Affordable Packages',
          content: 'Quality service doesn\'t have to be expensive. We offer competitive rates without compromising on comfort or safety. Our packages are designed to provide excellent value for money.'
        },
        {
          subtitle: '4. Years of Experience',
          content: 'With years of experience in the travel industry, we understand what travelers need. Our expertise ensures smooth operations and memorable journeys for all our customers.'
        },
        {
          subtitle: '5. Easy Booking Process',
          content: 'Booking with us is simple and convenient. You can book online through our website or call our customer support team. We offer flexible payment options and instant confirmation.'
        }]

      },
      {
        title: 'Book Your Chandigarh to Dharamshala Tour Package Today',
        content: 'Ready to explore the spiritual and scenic beauty of Dharamshala? Book your Chandigarh to Dharamshala tour package with Advait Tour and Travels today. Contact us now to reserve your vehicle and start planning your unforgettable journey to the mountains.'
      }]

    }
  },
  'patiala-amritsar': {
    from: 'Patiala',
    to: 'Amritsar',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [
    { id: '2-days', label: '2 Days' },
    { id: '3-days', label: '3 Days' },
    { id: '4-days', label: '4 Days' },
    { id: '5-days', label: '5 Days' },
    { id: '6-days', label: '6 Days' },
    { id: '7-days', label: '7 Days' },
    { id: '8-days', label: '8 Days' }],

    vehicles: [
    {
      type: 'Maruti Dzire',
      luggage: 3,
      seats: 4,
      price: 16800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'White Maruti Dzire sedan car for Amritsar to Dalhousie tour'
    },
    {
      type: 'Toyota Etios',
      luggage: 3,
      seats: 4,
      price: 18480,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
      alt: 'Toyota Etios sedan for comfortable Amritsar to Dalhousie travel'
    },
    {
      type: 'Brezza',
      luggage: 4,
      seats: 4,
      price: 20160,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png",
      alt: 'Maruti Brezza compact SUV for Amritsar to Dalhousie journey'
    },
    {
      type: 'Maruti Ertiga',
      luggage: 4,
      seats: 6,
      price: 21840,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
      alt: 'Maruti Ertiga MPV with spacious seating for Dalhousie tour'
    },
    {
      type: 'Innova Crysta',
      luggage: 6,
      seats: 6,
      price: 28560,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
      alt: 'Toyota Innova Crysta luxury MPV for premium Dalhousie travel'
    },
    {
      type: 'Innova Hycross',
      luggage: 5,
      seats: 6,
      price: 35280,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png",
      alt: 'Toyota Innova Hycross latest model for comfortable Dalhousie trip'
    },
    {
      type: 'Tempo Traveller',
      luggage: 8,
      seats: 12,
      price: 47040,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      alt: 'Tempo Traveller 12 seater for group travel to Dalhousie'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 17,
      price: 50400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
      alt: 'Tempo Traveller 17 seater for large group Dalhousie tour'
    },
    {
      type: 'Force Urbania',
      luggage: 16,
      seats: 16,
      price: 63840,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      alt: 'Force Urbania 16 seater luxury van for premium Dalhousie travel'
    },
    {
      type: 'Tempo Traveller',
      luggage: 15,
      seats: 25,
      price: 63840,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      alt: 'Tempo Traveller 25 seater for extra large group Dalhousie tour'
    }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-char-dham': {
    from: 'Patiala',
    to: 'Char Dham',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [{ id: '2-days', label: '2 Days' }, { id: '3-days', label: '3 Days' }, { id: '4-days', label: '4 Days' }, { id: '5-days', label: '5 Days' }, { id: '6-days', label: '6 Days' }, { id: '7-days', label: '7 Days' }, { id: '8-days', label: '8 Days' }],
    vehicles: [
    { type: 'Maruti Dzire', luggage: 3, seats: 4, price: 31000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png", alt: 'White Maruti Dzire sedan car for Patiala to Char Dham tour' },
    { type: 'Toyota Etios', luggage: 3, seats: 4, price: 34100, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png", alt: 'Toyota Etios sedan for comfortable Patiala to Char Dham travel' },
    { type: 'Brezza', luggage: 4, seats: 4, price: 37200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png", alt: 'Maruti Brezza compact SUV for Patiala to Char Dham journey' },
    { type: 'Maruti Ertiga', luggage: 4, seats: 6, price: 40300, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png", alt: 'Maruti Ertiga MPV with spacious seating for Char Dham tour' },
    { type: 'Innova Crysta', luggage: 6, seats: 6, price: 52700, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png", alt: 'Toyota Innova Crysta luxury MPV for premium Char Dham travel' },
    { type: 'Innova Hycross', luggage: 5, seats: 6, price: 65100, image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png", alt: 'Toyota Innova Hycross latest model for comfortable Char Dham trip' },
    { type: 'Tempo Traveller', luggage: 8, seats: 12, price: 86800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png", alt: 'Tempo Traveller 12 seater for group travel to Char Dham' },
    { type: 'Tempo Traveller', luggage: 15, seats: 17, price: 93000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png", alt: 'Tempo Traveller 17 seater for large group Char Dham tour' },
    { type: 'Force Urbania', luggage: 16, seats: 16, price: 117800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png", alt: 'Force Urbania 16 seater luxury van for premium Char Dham travel' },
    { type: 'Tempo Traveller', luggage: 15, seats: 25, price: 117800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png", alt: 'Tempo Traveller 25 seater for extra large group Char Dham' }],
    visitorsGuide: {
      title: 'Experience the Spiritual Amritsar to Char Dham Journey with Advait Tour and Travels',
      description: "Embark on a sacred pilgrimage from Amritsar to Char Dham.",
      sections: []
    }
  },
  'patiala-badrinath-kedarnath': {
    from: 'Patiala',
    to: 'Badrinath Kedarnath',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [{ id: '5-days', label: '5 Days' }, { id: '6-days', label: '6 Days' }, { id: '7-days', label: '7 Days' }, { id: '8-days', label: '8 Days' }],
    vehicles: [
    { type: 'Maruti Dzire', luggage: 3, seats: 4, price: 25000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_180dd98ea-1768379490874.png", alt: 'White Maruti Dzire sedan car for Patiala to Badrinath Kedarnath tour' },
    { type: 'Toyota Etios', luggage: 3, seats: 4, price: 27500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_109a9f6bf-1768379759524.png", alt: 'Toyota Etios sedan for comfortable Patiala to Badrinath Kedarnath travel' },
    { type: 'Brezza', luggage: 4, seats: 4, price: 30000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1de88d83e-1768380471356.png", alt: 'Maruti Brezza compact SUV for Patiala to Badrinath Kedarnath journey' },
    { type: 'Maruti Ertiga', luggage: 4, seats: 6, price: 32500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png", alt: 'Maruti Ertiga MPV with spacious seating for Badrinath Kedarnath tour' },
    { type: 'Innova Crysta', luggage: 6, seats: 6, price: 42500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png", alt: 'Toyota Innova Crysta luxury MPV for premium Badrinath Kedarnath travel' },
    { type: 'Innova Hycross', luggage: 5, seats: 6, price: 52500, image: "https://img.rocket.new/generatedImages/rocket_gen_img_179ca4a8c-1768360986311.png", alt: 'Toyota Innova Hycross latest model for comfortable Badrinath Kedarnath trip' },
    { type: 'Tempo Traveller', luggage: 8, seats: 12, price: 70000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png", alt: 'Tempo Traveller 12 seater for group travel to Badrinath Kedarnath' },
    { type: 'Tempo Traveller', luggage: 15, seats: 17, price: 75000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png", alt: 'Tempo Traveller 17 seater for large group Badrinath Kedarnath' },
    { type: 'Force Urbania', luggage: 16, seats: 16, price: 95000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png", alt: 'Force Urbania 16 seater luxury van for premium Badrinath Kedarnath travel' },
    { type: 'Tempo Traveller', luggage: 15, seats: 25, price: 95000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png", alt: 'Tempo Traveller 25 seater for large group Badrinath Kedarnath' }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  },
  'patiala-char-dham': {
    from: 'Patiala',
    to: 'Char Dham',
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    days: [{ id: '2-days', label: '2 Days' }, { id: '3-days', label: '3 Days' }, { id: '4-days', label: '4 Days' }, { id: '5-days', label: '5 Days' }, { id: '6-days', label: '6 Days' }, { id: '7-days', label: '7 Days' }, { id: '8-days', label: '8 Days' }],
    vehicles: [
    { type: 'Maruti Dzire', luggage: 3, seats: 4, price: 31000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png", alt: 'White Maruti Dzire sedan car for Patiala to Char Dham tour' },
    { type: 'Toyota Etios', luggage: 3, seats: 4, price: 34100, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ce3b07-1768382337923.png", alt: 'Toyota Etios sedan for comfortable Patiala to Char Dham travel' },
    { type: 'Brezza', luggage: 4, seats: 4, price: 37200, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3a6ed08-1768371331213.png", alt: 'Maruti Brezza compact SUV for Patiala to Char Dham journey' },
    { type: 'Maruti Ertiga', luggage: 4, seats: 6, price: 40300, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png", alt: 'Maruti Ertiga MPV with spacious seating for Char Dham tour' },
    { type: 'Innova Crysta', luggage: 6, seats: 6, price: 52700, image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png", alt: 'Toyota Innova Crysta luxury MPV for premium Char Dham travel' },
    { type: 'Innova Hycross', luggage: 5, seats: 6, price: 65100, image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png", alt: 'Toyota Innova Hycross latest model for comfortable Char Dham trip' },
    { type: 'Tempo Traveller', luggage: 8, seats: 12, price: 86800, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png', alt: 'Tempo Traveller 12 seater for group travel to Char Dham' },
    { type: 'Tempo Traveller', luggage: 15, seats: 17, price: 93000, image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png', alt: 'Tempo Traveller 17 seater for large group Char Dham' },
    { type: 'Force Urbania', luggage: 16, seats: 16, price: 117800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png", alt: 'Force Urbania 16 seater luxury van for premium Char Dham' },
    { type: 'Tempo Traveller', luggage: 15, seats: 25, price: 117800, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png", alt: 'Tempo Traveller 25 seater for large group Char Dham' }],

    visitorsGuide: {
      title: "Visitor\'s Guide",
      description: "We\'re here for you 24/7!",
      contact: "+91-79986-66660"
    }
  }
};